import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { timeMinuteDefaults } from "../../util/timeMinuteDefaults.jsx";

const ModalProgram = ({
  // hours,
  // minutes,
  setNewProgramDetails,
  newProgramDetails,
  programsData,
  setShowModalProgram,
  handleNewProgramSave,
}) => {
  var { hours, minutes } = timeMinuteDefaults();
  return (
    <>
      {" "}
      <Modal.Header closeButton>
        <Modal.Title>Add Program</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="pt-2 ">
            <Col xs={4}>
              <small>Select Program </small>
            </Col>
            <Col>
              <Form.Select
                id="newProgramId"
                size="sm"
                onChange={(e) => {
                  setNewProgramDetails({
                    ...newProgramDetails,
                    _id: e.target.value,
                  });
                }}
                value={newProgramDetails._id}
              >
                <>
                  {programsData &&
                    programsData.map((program, i) => (
                      <option
                        value={program._id}
                        key={i}
                      >
                        {program.name}
                      </option>
                    ))}
                </>
              </Form.Select>
            </Col>
          </Row>
          <Row className="pt-2">
            <Col
              xs={4}
              className="align-self-center text-end "
            >
              <small>Start Time:</small>
            </Col>
            <Col xs={3}>
              <Form.Select
                id="newProgramHours"
                size="sm"
                onChange={(e) => {
                  setNewProgramDetails({
                    ...newProgramDetails,
                    startHours: parseInt(e.target.value),
                  });
                }}
                value={newProgramDetails?.startHours || 0}
              >
                {hours.map((i) => (
                  <option
                    value={i}
                    key={i}
                  >
                    {i < 12 ? i + " am" : i + " pm"}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col xs={3}>
              <Form.Select
                id="newProgramMinutes"
                size="sm"
                onChange={(e) => {
                  setNewProgramDetails({
                    ...newProgramDetails,
                    startMinutes: parseInt(e.target.value),
                  });
                }}
                value={newProgramDetails?.startMinutes || 0}
              >
                {minutes.map((i) => (
                  <option
                    value={i}
                    key={i}
                  >
                    {i + " mins"}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            setShowModalProgram(false);
            setNewProgramDetails({
              _id: programsData ? programsData[0]._id : "",
              startHours: 0,
              startMinutes: 0,
            });
          }}
        >
          Close
        </Button>
        <Button
          variant="primary"
          onClick={handleNewProgramSave}
        >
          Save
        </Button>
      </Modal.Footer>
    </>
  );
};
export default ModalProgram;
